module.exports = __webpack_public_path__ + "static/media/gClndIcon.570004c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/gClndIcon.png
// module id = 19
// module chunks = 0